angular.module("Main").directive("kundenportalWizard", wizzard);

function wizzard() {
    return {
        templateUrl: "./app/Main/controls/bookingWizard/kundenportalWizard.html",
        restrict: "EA",
        controller: KundenportalWizardController,
        controllerAs: "vm",
        scope: true,
        link: function (scope, element, attrs) {
            scope.active = scope.$eval(attrs.active);
            scope.clubId = scope.$eval(attrs.clubId);
            scope.isLoggedIn = scope.$eval(attrs.isLoggedIn)
        }
    };
}

KundenportalWizardController.$inject = ["$scope", "$rootScope", "$stateParams", "$state", "$localStorage", "SessionService", "BookingService"];

function KundenportalWizardController($scope, $rootScope, $stateParams, $state, $localStorage, SessionService, BookingService) {
    var vm = this;


    getKursbuchungLayouKonfiguration();
    getCustomerName();
    checkLogin();
    getBSLinks();
    getKPConfig();

    if (screen.width < 600) {
        vm.isMobilePhone = true;
    } else {
        vm.isMobilePhone = false;
    }

    function getKursbuchungLayouKonfiguration() {
        BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
            vm.kursbuchungConfig = data;
        })
    }

    function getCustomerName() {
        BookingService.getCustomerName().then(function (companyName) {
            vm.companyName = companyName;
        });
    }

    function checkLogin() {
        vm.currentUser = $localStorage.user;
        vm.isLoggedInKundenportal = (!_.isNil(vm.currentUser));
        if (!_.isNil(vm.currentUser)) {
            vm.isLoggedIn = true;
            vm.username = $localStorage.user.username;
        }
    }

    function getKPConfig() {
        BookingService.getKPConfig().then(function (data) {
            vm.kundenportalConfig = data;
        })
    }

    var loginHandler = $rootScope.$on("loginKundenportal", function () {
        vm.isLoggedIn = true;
        vm.username = $localStorage.user.username;
        vm.isLoggedInKundenportal = true;
    });

    vm.logout = function () {
        SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
        vm.isLoggedIn = false;
        vm.username = "";
        $localStorage.user = {};
        vm.isLoggedInKundenportal = false;
        SessionService.setAuthDataId($stateParams.cid);
        $rootScope.$emit("logout");
        $state.go('customer')
    };

    function getBSLinks() {
        BookingService.getCCLinkIdKurse().then(function (data) {

            if (data.Aktiv === 1) {
                vm.kurseAktiv = true;
                vm.LinkIdCCKurse = data.Id;
            } else {
                vm.kurseAktiv = false
            }
        });
        BookingService.getCCLinkIdTerminbuchung().then(function (data) {
            if (data.Aktiv === 1) {
                vm.termineAktiv = true;
                vm.LinkIdCCTermine = data.Id;
            } else {
                vm.termineAktiv = false
            }
        })
    }

    vm.gotToTBCCLink = function () {
        $state.go('angebot', {cid: SessionService.getAuthData(), id: vm.LinkIdCCTermine});
    };

    vm.gotToKBCCLink = function () {
        $state.go('kursplan', {cid: SessionService.getAuthData(), id: vm.LinkIdCCKurse});
    };

    vm.openMenuBar = function () {
        if (vm.openedMenuBar === false) {
            vm.openedMenuBar = true;
        } else {
            vm.openedMenuBar = false;
        }
    }

}